import styles from "./Hamburger.module.css";

const Hamburger = ({ open, onToggle }) => {
  const toggle = () => onToggle(!open);

  return (
    <button
      type="button"
      aria-pressed={open}
      aria-label="Menu"
      title="Menu"
      onClick={toggle}
      className={`${styles.button} ${open ? styles.open : ""}`}
      data-testid="hamburger"
    >
      <span className={styles.srOnly}>{open ? "Close" : "Open"} menu</span>
      <span className={styles.line} />
      <span className={styles.line} />
      <span className={styles.line} />
      <span className={styles.line} />
    </button>
  );
};

export default Hamburger;
